"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("./Icon"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var DeleteIcon = function DeleteIcon(_ref) {
  var deleteFunc = _ref.deleteFunc,
      padding = _ref.padding;
  return _react["default"].createElement("div", null, _react["default"].createElement(_Icon["default"], {
    onClick: deleteFunc,
    style: padding ? {
      padding: "0.75rem"
    } : {},
    iconName: "fa-trash-alt",
    className: "fa-md",
    title: "Delete"
  }));
};

DeleteIcon.defaultProps = {
  padding: false
};
DeleteIcon.propTypes = {
  /** Function to call for when deleting */
  deleteFunc: _propTypes["default"].func.isRequired,

  /** should the icon contain padding or not */
  padding: _propTypes["default"].bool
};
var _default = DeleteIcon;
exports["default"] = _default;